import { uniqBy } from 'lodash';
import { useDebounce } from '@app/common/hooks/use-debounce-component-value';
import { useAllSourcePluginsSearch } from '@modules/plugins/use-all-source-plugins-search';
import { useUserPluginRestrictedMode } from '../hooks/user-restricted-modes';
import { toPluginSelectItem } from './formatters';
/** @deprecated */
export function useAllFormattedPluginsSelectOptions(filter, renderSource = true) {
    const debouncedFilter = useDebounce(filter, 500);
    const { isRestricted } = useUserPluginRestrictedMode();
    const { plugins, isLoading, isFetching } = useAllSourcePluginsSearch(debouncedFilter, isRestricted, true);
    const data = uniqBy(plugins, 'key').map(plugin => toPluginSelectItem(toLegacySource(plugin), renderSource));
    return { data, isLoading, isFetching };
}
function toLegacySource(plugin) {
    return { ...plugin, source: plugin.source === 'BUNDLED' ? 'MARKETPLACE' : plugin.source };
}
